import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'react-bootstrap';
import AgreementsModal from 'containers/request/Initial/Agreements/AgreementsModal';
import { WithModal, IconLabel, Bubble } from 'ctia-ui';
import { toggleCheckbox } from 'actions/request';
import { downloadAgreement, downloadAgreementBlank } from 'actions/agreement';
import LicenseAgreementContent from 'containers/request/Initial/Agreements/LicenseAgreementContent';

class LicenseAgreement extends WithModal {
  onPrintClick = () => {
    const {
      downloadAgreement,
      downloadAgreementBlank,
      request,
      agreement,
      user
    } = this.props;

    if (agreement && !_.isUndefined(agreement.document)) {
      downloadAgreement(request);
    } else {
      downloadAgreementBlank(user.company, request.modelName);
    }
  };

  renderCheckboxElement = () => {
    const { id, isSaved, agreementAccepted } = this.props.request;

    if (isSaved === false && agreementAccepted) {
      return (
        <h3 className="green">
          <IconLabel awesomeIcon="check-circle" />
          License Agreement Accepted
        </h3>
      );
    }

    if (this.props.user.isStaff) {
      return (
        <Bubble type="warning">
          Only manufacturer can accept the agreement.
        </Bubble>
      );
    }

    return (
      <Checkbox
        id="agreementAccepted"
        onChange={this.props.toggleCheckbox}
        value={agreementAccepted}
        checked={agreementAccepted}
        disabled={id > 0 && !isSaved}
      >
        <strong>I accept the license agreement terms and conditions</strong>
      </Checkbox>
    );
  };

  render() {
    return (
      <div>
        <h3>
          <strong>License Agreement</strong>
        </h3>
        <p className="agr-description">
          Once the device is certified, the certification license agreement
          becomes effective. Please review the agreement{' '}
          <a onClick={this.handleModal} className="agr-link">
            here
          </a>{' '}
          and click the accept box below.
        </p>
        <p className="agr-description">
          I understand and acknowledge that my company agrees to the Terms and
          Conditions for the specified device set forth in the link above that
          will become effective immediately upon the date of device
          certification.
        </p>
        <div className="text-center agr-description">
          {this.renderCheckboxElement()}
        </div>
        <AgreementsModal
          show={this.state.showModal}
          modalHandler={this.handleModal}
          downloadHandler={this.onPrintClick}
          content={LicenseAgreementContent}
        />
        <hr />
      </div>
    );
  }
}

function mapStateToProps({ request, user, agreement }) {
  return { request, user, agreement };
}

export default connect(
  mapStateToProps,
  {
    toggleCheckbox,
    downloadAgreement,
    downloadAgreementBlank
  }
)(LicenseAgreement);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Agreements/LicenseAgreement.js